import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("GuestFillOutStore");
export const useGuestFillOutStoreActions = useActions;
export const useGuestFillOutStoreGetters = useGetters;
export const useGuestFillOutStoreMutations = useMutations;
export const useGuestFillOutStoreState = useState;